var map = {
	"./common/empty.png": 81833,
	"./common/frame-corner-bottom-left.png": 25741,
	"./common/frame-corner-bottom-right.png": 1070,
	"./common/frame-corner-top-left.png": 95563,
	"./common/frame-corner-top-right.png": 59988,
	"./common/gift.png": 11710,
	"./common/hot.gif": 18668,
	"./event/top-bg.png": 24456,
	"./event/top-right.png": 77815,
	"./event/top-shell-bg.png": 7867,
	"./footer/border-body.png": 95063,
	"./footer/border-top.png": 29378,
	"./header/dropdown-arrow.png": 67499,
	"./header/menu-toggle.png": 57184,
	"./header/mobile-arrow.png": 10182,
	"./home/banner-bg.png": 39958,
	"./home/category-favorite.webp": 41482,
	"./home/category-hot-active.png": 31677,
	"./home/category-hot.png": 38348,
	"./home/category-popular.webp": 44987,
	"./home/category-recent-active.png": 84193,
	"./home/category-recent.png": 70152,
	"./home/category-recent.webp": 42037,
	"./home/category-slots.webp": 27759,
	"./home/event-card-corner-bottom-left.png": 3301,
	"./home/event-card-corner-bottom-right.png": 31846,
	"./home/event-card-corner-top-left.png": 43027,
	"./home/event-card-corner-top-right.png": 46236,
	"./home/frame-corner-bottom-left.png": 71467,
	"./home/frame-corner-bottom-right.png": 70708,
	"./home/frame-corner-top-left.png": 88589,
	"./home/frame-corner-top-right.png": 61166,
	"./home/game-section-header-bg.png": 11152,
	"./home/jackpot-bg.png": 13676,
	"./home/notice-icon.webp": 43675,
	"./home/page-bg.png": 1415,
	"./home/redeem-code-icon.png": 46722,
	"./home/search-active.png": 41083,
	"./home/search.png": 21078,
	"./login/exit-confirm-bg.png": 6081,
	"./login/popup-bg.png": 7404,
	"./notification/bg-top1.png": 83372,
	"./person/avatar.png": 29699,
	"./person/bg-vip.png": 12651,
	"./person/bg-vipBottom.png": 41722,
	"./person/bg-vipPc.png": 36960,
	"./person/icon-Deposit.png": 53558,
	"./person/icon-DepositVip.png": 46109,
	"./person/icon-History.png": 53604,
	"./person/icon-Install.png": 67797,
	"./person/icon-Notification.png": 10343,
	"./person/icon-Senha.png": 52283,
	"./person/icon-Transaction.png": 34820,
	"./person/icon-Withdraw.png": 72152,
	"./person/icon-arrow.png": 65987,
	"./person/icon-betsVip.png": 64273,
	"./person/icon-exchange.png": 93061,
	"./person/icon-service.png": 2897,
	"./person/icon_Wallet.png": 27011,
	"./person/icon_copy.png": 21163,
	"./person/icon_logout.png": 64150,
	"./person/icon_notification.png": 66789,
	"./person/vip-center-bg.png": 18765,
	"./share/TreasureChest.png": 39188,
	"./share/TreasureLock.png": 62838,
	"./share/TreasureUnLock.png": 37639,
	"./share/bg-shareMoney.png": 83943,
	"./share/bg-sharePeople.png": 130,
	"./share/bg-top.png": 39175,
	"./share/facebook.png": 27876,
	"./share/icon_fackbook.png": 4550,
	"./share/icon_howShare.png": 28543,
	"./share/icon_ins.png": 92986,
	"./share/icon_inviteDate.png": 34819,
	"./share/icon_telegram.png": 68701,
	"./share/icon_tiktok.png": 12342,
	"./share/icon_whatsapp.png": 53642,
	"./share/icon_x.png": 61514,
	"./share/icon_youtube.png": 32245,
	"./share/invite_banner1.png": 41281,
	"./share/invite_banner2.png": 10698,
	"./share/invite_banner3.png": 65907,
	"./share/invite_banner4.png": 94684,
	"./share/proxy.png": 68950,
	"./share/redemption-code-title.png": 35320,
	"./share/share_bg.png": 68981,
	"./share/trumpet.png": 24469,
	"./sidebar/affiliate-active.png": 75207,
	"./sidebar/affiliate.png": 10154,
	"./sidebar/copy.png": 7464,
	"./sidebar/customer-service.png": 6601,
	"./sidebar/hot-bg.png": 48520,
	"./sidebar/invite-free.png": 89337,
	"./sidebar/language-arrow.png": 67181,
	"./sidebar/menu-item-border.png": 78213,
	"./sidebar/path-arrow.png": 76454,
	"./sidebar/promotion-active.png": 42485,
	"./sidebar/promotion.png": 58740,
	"./sidebar/redemption-code-active.png": 8649,
	"./sidebar/redemption-code.png": 39360,
	"./sidebar/refresh.png": 3838,
	"./sidebar/share-panel-bg.png": 41655,
	"./sidebar/sidebar-border.png": 30424,
	"./sidebar/social-media-active.png": 50530,
	"./sidebar/social-media.png": 39441,
	"./sidebar/telegram.gif": 83701,
	"./sidebar/vip-active.png": 21339,
	"./sidebar/vip-badge.png": 68332,
	"./sidebar/vip.png": 75222,
	"./signIn/suo.png": 33320,
	"./signIn/vipicon.png": 89453,
	"./signIn/vipiconact.png": 55145,
	"./tabbar/active-corner-bottom-left.png": 66519,
	"./tabbar/active-corner-bottom-right.png": 15784,
	"./tabbar/active-corner-top-left.png": 72057,
	"./tabbar/active-corner-top-right.png": 65762,
	"./tabbar/affiliate-active.png": 10217,
	"./tabbar/affiliate.png": 43008,
	"./tabbar/home-active.png": 83289,
	"./tabbar/home.png": 62928,
	"./tabbar/menu-active.png": 94225,
	"./tabbar/menu.png": 23512,
	"./tabbar/profile-active.png": 79239,
	"./tabbar/profile.png": 37610,
	"./tabbar/sport.png": 24131,
	"./tabbar/vip-active.png": 20633,
	"./tabbar/vip.png": 20528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60457;